import { render, staticRenderFns } from "./CustomerEditContactsTab.vue?vue&type=template&id=4d0fc8f0"
import script from "./CustomerEditContactsTab.vue?vue&type=script&lang=ts"
export * from "./CustomerEditContactsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports